import { combineReducers } from '@reduxjs/toolkit';
import { cartReducer } from './cart';
import { uiReducer } from './ui';
import { authReducer } from './auth';
import { productReducer } from '../integrations/woocommerce/productSlice';
import { wishlistReducer } from './wishlist';
import { reviewsReducer } from './reviews';
import { checkoutReducer } from './checkout';

const rootReducer = combineReducers({
  ui: uiReducer,
  cart: cartReducer,
  auth: authReducer,
  products: productReducer,
  wishlist: wishlistReducer,
  reviews: reviewsReducer,
  checkout: checkoutReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
